import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=612f7815&lang=css"
import "./App.vue?vue&type=style&index=1&id=612f7815&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=2&id=612f7815&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-612f7815"]])

export default __exports__